export default __webpack_public_path__ + "static/media/Certilytics-Logo-Icons-4.3ce53532.svg";